import {defaultRateLimits} from "./data";

export const defaultConfig = (accountId, configs) => ({
  apiToken : null,
  apiChecked: configs.length ? !configs[0].apiChecked : false,
  hostname: "", // This is only for resellers, NOT api users!
  accountId: accountId, // For being able to associate
  rateLimits: [], // [defaultRateLimits(),defaultRateLimits(["Create"])],
  hostnameRateLimits: [], // [defaultRateLimits(),defaultRateLimits(["Create"])],
  // Do not change unless for chatmeter testing :)
  hostnameLimited: true,
  isNew: true,
  dirty: []
})

export const buildUpdate = (key, value, index, isFinal, transformer) => {
  return {
    [key] : transformer ? transformer(value) : value,
    isFinal: !!isFinal,
    index
  }
}

export const hideClass = (obj) => {
  return obj.deleted ? ' hide' : ''
}

export const isNullyField = (item) => {
  return !item || (item && item === '')
}
